import React from 'react';
import { Typography, useTheme } from '@material-ui/core';
import { useTranslate } from 'react-admin';

interface FPSCounterProps {
  fps: number;
}

export const FPSCounter: React.FC<FPSCounterProps> = ({ fps }) => {
  const theme = useTheme();
  const translate = useTranslate();

  // Color based on FPS performance
  const getFPSColor = () => {
    if (fps >= 55) return '#4caf50'; // Green - good
    if (fps >= 30) return '#ff9800'; // Orange - moderate
    return '#f44336'; // Red - poor
  };

  return (
    <Typography
      component="div"
      variant="body2"
      style={{
        position: 'absolute',
        top: '10px',
        left: '10px',
        background: 'rgba(0, 0, 0, 0.7)',
        color: getFPSColor(),
        padding: '8px 12px',
        borderRadius: '4px',
        fontSize: '14px',
        fontWeight: 'bold',
        zIndex: 1000,
        pointerEvents: 'none',
        userSelect: 'none',
        border: `2px solid ${getFPSColor()}`,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
      }}
    >
      {translate('osfc.storage_ui.fps.label', { value: fps })}
    </Typography>
  );
};
